import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDvkHoEe3kEb-3mhd8UYpnjsY5lfaTJduY',
  authDomain: 'preventivatoreweb.firebaseapp.com',
  projectId: 'preventivatoreweb',
  storageBucket: 'preventivatoreweb.firebasestorage.app',
  messagingSenderId: '864779882266',
  appId: '1:864779882266:web:3d2e56bd564da9ffd226a3',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1');
export const storage = getStorage(app);
